import { View } from "binder"
import { CashGatewayViewModel } from "./cashGateway-viewModel"
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";

export class CashGatewayView extends View<CashGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-D43CC084-7DD2-4A5B-B218-DCCFA1A7F548"
    }
    loadHtml(): string {
        let element = require('./cashGateway.html').default;
        let style = require('./cashGateway.less');
        return element;
    }
    constructor() {
       super();
    }

    public set district(v: DistrictSelectorViewModel) { this._district = v; } public get district(): DistrictSelectorViewModel { return this._district;} private _district: DistrictSelectorViewModel;
}
